import { reduceTokenString } from '@/common/utils/app.utils';
// Accept a variety of job response shapes (submit or poll) — keep data as any
import tokens from '@/dashboard/tokens.json';
import { JobStatusResponse, SubmitBatchResponse } from '@/dashboard/services/dashboardApi';

type SubmitAppStates = 'init' | 'loading' | 'request-error' | 'batch-ok' | 'batch-error';
export interface SubmitButtonAppState {
  state: SubmitAppStates;
  alert: null | string;
  period: string;
}

export const submitAppInitialState: Pick<SubmitButtonAppState, 'state' | 'alert'> = {
  state: 'init',
  alert: null,
};

export type PostSubmitAction =
  | { type: 'REQUEST_ERROR'; error: string }
  | { type: 'BATCH_OK'; message: string; data?: SubmitBatchResponse | JobStatusResponse | null }
  | { type: 'BATCH_ERROR'; message: string; data?: SubmitBatchResponse | JobStatusResponse | null }
  | { type: 'RESET' };

export function initSubmitState(period: string): SubmitButtonAppState {
  return {
    state: 'init',
    alert: null,
    period,
  };
}

function postSubmitReducer(
  state: SubmitButtonAppState,
  action: PostSubmitAction,
): SubmitButtonAppState {
  switch (action.type) {
    case 'REQUEST_ERROR':
      return {
        ...state,
        state: 'request-error',
        alert: action.error,
      };
    case 'BATCH_OK': {
      const alert = reduceTokenString(tokens['BATCH_SUBMIT_OK'], state.period);
      return {
        ...state,
        state: 'batch-ok',
        alert,
      };
    }
    case 'BATCH_ERROR': {
      const alert = reduceTokenString(tokens['BATCH_SUBMIT_FAILURE'], state.period);
      return {
        ...state,
        state: 'batch-error',
        alert,
      };
    }
    case 'RESET':
    default:
      return {
        ...submitAppInitialState,
        period: state.period,
      };
  }
}

export default postSubmitReducer;
